export default __webpack_public_path__ + "static/media/cab.3102887f.png";